import _cloneDeep from 'lodash/cloneDeep';

/**
 * NotificationsService class.
 * Use this service to manage notifications by configuration.
 */
export default class NotificationsService {
    /**
     * @param {RemoteConfigService} RemoteConfigService - Service to get configuration from API/server
     * @constructor
     * @ngInject
     */
    constructor(RemoteConfigService) {
        this.RemoteConfigService = RemoteConfigService;

        this.config = _cloneDeep(this.RemoteConfigService.getNotificationsConfig());

        this.items = this.config.items || [];
        this.itemsMapByStatus = {};

        this.defaultNotification = {
            exclamation: false,
            color: ''
        };

        this.createNotificationsMapByStatus();
    }

    /**
     * Parse config items and create map for notifications by notification.status
     * @returns {Object} Return object with notifications linked to notification.status inside that object}
     */
    createNotificationsMapByStatus() {
        if (!this.items || !Array.isArray(this.items) || !this.items.length) return {};

        this.items.forEach((notification) => {
            this.itemsMapByStatus[notification.status] = notification;
        });

        this.sortNotificationsMap();

        return this.getNotificationsMapByStatus();
    }

    /**
     * Sort notifications map by notification.status
     * @returns {Object} Map of notifications
     */
    sortNotificationsMap() {
        this.itemsMapByStatus = Object.keys(this.itemsMapByStatus).sort().reduce((result, item) => {
            result[item] = this.itemsMapByStatus[item];

            return result;
        }, {});

        return this.itemsMapByStatus;
    }

    /**
     * Get default notification
     * @returns {{exclamation: boolean, color: string}} Return default object for notification
     */
    getDefaultNotification() {
        return this.defaultNotification;
    }

    /**
     * Get notification by status
     * @param {string} status - Status name
     * @returns {{exclamation: boolean, color: string}} Return found notification by status from map or default
     * notification
     */
    getNotificationByStatus(status) {
        return this.itemsMapByStatus[status] || this.getDefaultNotification();
    }

    /**
     * Get all notifications (NOTICE: Original notifications configs from API/Server)
     * @returns {Array} Return list of notification configs
     */
    getAllNotifications() {
        return this.items;
    }

    /**
     * Get notification by status from map
     * @returns {{}} Return map of notifications by status
     */
    getNotificationsMapByStatus() {
        return this.itemsMapByStatus;
    }
}



// WEBPACK FOOTER //
// ./app/services/notifications/notifications.service.js